<h1>Välkommen</h1>
<form [formGroup]="welcomeForm()" class="welcome-holder">
  <p>
    @if (routeService.onHorseRoute()) {
      Välkommen till ansökan om att starta ett sparande hos Sparbanken Syd!
    } @else {
      Välkommen till ansökan om att placera ditt sparande hos Sparbanken Syd!
    }
  </p>

  <p>Vi kommer nu att ställa ett antal frågor till dig då vi som bank, enligt
    lag, måste ha en dokumenterad kännedom om dig och dina affärer.</p>

  <p>När din ansökan är godkänd så kommer vi att kontakta dig när produkter
    och
    tjänster är upplagda. </p>

  <p>Banken förbehåller sig rätten att neka öppning av konto. <a
    spbAccessibleLink
    href="https://www.sparbankensyd.se/sv/privat/om-oss/sakerhet-kundskydd/kundskydd-betalningar"
    target="_blank">
    Klicka här för att läsa mer</a></p>

  <mat-checkbox
    [class.selection-error]="welcomeForm().get('terms')?.invalid && (welcomeForm().get('terms')?.touched || stepper().steps.first.interacted)"
    formControlName="terms"
    aria-required="true"
    [attr.aria-invalid]="welcomeForm().get('terms')?.invalid && welcomeForm().get('terms')?.touched"
    [attr.aria-describedby]="welcomeForm().get('terms')?.invalid ? 'terms-error' : null"
    (keydown.enter)="welcomeForm().patchValue({terms: !welcomeForm().get('terms')?.value}); $event.preventDefault()">
    Jag intygar att jag har tagit del av
    informationen om behandling av
    personuppgifter <a
    spbAccessibleLink
    href="https://www.sparbankensyd.se/sv/om-oss/sakerhet-kundskydd/integritet-och-sekretess-gdpr"
    target="_blank">
    Klicka här för att läsa mer</a>
  </mat-checkbox>

  @if (welcomeForm().get('terms')?.invalid && (welcomeForm().get('terms')?.touched || stepper().steps.first.interacted)) {
    <div class="mat-error-container">
      <mat-icon
        class="negative"
        aria-hidden="true">
        priority_high
      </mat-icon>

      <mat-error id="terms-error">
        Du behöver kryssa i rutan för att kunna fortsätta
      </mat-error>
    </div>
  }
</form>